import React, {ChangeEvent, MutableRefObject, useEffect, useRef, useState} from "react";
import "./SignatureTyping.scss"
import styled from "styled-components";
import {CONSTANTS} from "../../../../common/constants";
import {ToastService} from "../../../../service/ToastService";

interface SignatureTypingProps {
    onSetText: (text: string) => void;
    clearFlag: boolean;
    maxLength: number;
}

const StyledSignatureTypingInput = styled.input`
  &&& {
    height: ${CONSTANTS.SIGNATURE_CONTAINER_HEIGHT}px;
  }
`;

export const SignatureTyping: React.FunctionComponent<SignatureTypingProps> = (props) => {
    const inputRef = useRef<HTMLInputElement>() as MutableRefObject<HTMLInputElement>;
    const [text, setText] = useState<string>('')

    useEffect(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [false]);

    useEffect(() => {
        if (props.clearFlag) {
            setText('');
        }
    }, [props.clearFlag]);

    const onChange = (event: ChangeEvent) => {
        const newText = (event.target as HTMLInputElement).value;
        if(newText.length > props.maxLength) {
            ToastService.middleScreenErrorToast('Signature should not be great than ' + props.maxLength + ' symbols');
            return;
        }
        setText(newText);
        props.onSetText(newText)
    }


    return (<div className={'signature-typing-container'}>
        <StyledSignatureTypingInput value={text} onChange={onChange} ref={inputRef} placeholder="Type Here"
                                    id="signature-text" type="text"/>
    </div>)
}
